import React from "react";
import { Box, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImportType } from "./components/types";

export const addOptions = [
  {
    text: "depotPage.addOptions.depots",
    testId: "depots",
    type: "",
    default: "01_depot",
  },
  {
    text: "depotPage.addOptions.cash",
    testId: "cash",
    type: "",
    default: "02_cash",
  },
  {
    text: "depotPage.addOptions.assets",
    testId: "assets",
    type: "manually",
    default: "05_material_assets",
  },
];

interface AddPortfolioMenuProps {
  menuEl: HTMLElement | null;
  handleCloseMenu: () => void;
  onSelect: (val: ImportType) => void;
}

export const AddOptionsList = ({
  onSelect,
}: {
  onSelect: (val: ImportType) => void;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return addOptions.map((option) => (
    <MenuItem
      key={`${option.testId}-create`}
      data-testid={`${option.testId}-create`}
      onClick={() => onSelect(option as ImportType)}
      sx={{
        padding: theme.spacing(1.5, 5, 1.5),
      }}
    >
      <Box width="100%" minWidth={220}>
        <Typography variant="body3" color="textSecondary">
          {t(option.text)}
        </Typography>
      </Box>
    </MenuItem>
  ));
};

function AddPortfolioMenu({
  menuEl,
  handleCloseMenu,
  onSelect,
}: AddPortfolioMenuProps) {
  return (
    <Menu
      id="new-portfolio-menu"
      open={Boolean(menuEl)}
      anchorEl={menuEl}
      keepMounted
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <AddOptionsList onSelect={onSelect} />
    </Menu>
  );
}

export default AddPortfolioMenu;
